<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Ürün İşlemleri
        </div>
        <el-row :gutter="10" style="margin-bottom: 20px">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <div class="padding-bottom-10">
                        <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                        text-color="gray">
                            <el-radio-button label="1">
                                <i class="mdi mdi-circle-edit-outline mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='1'">Aktif Ürün</label>
                                </transition>
                            </el-radio-button>
                            <el-radio-button label="0">
                                <i class="mdi mdi-circle-edit-outline  mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='0'">Pasif Ürün</label>
                                </transition>
                            </el-radio-button>
                        </el-radio-group>
                        <div class="aciklamaListesi">
                            <ul>
                                <li class="renk-duzenle"><i class="el-icon-edit"></i> Düzenle</li>
                                <li class="renk-silinen"><i class="mdi mdi-delete"></i> Sil</li>
                                <li class="renk-detay"><i class="mdi mdi-play"></i> Aktif Yap</li>
                            </ul>
                        </div>
                    </div>
                    <el-table
                            border
                            :data="urunListesi"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="urunAdi"
                                label="Ürün Adı"
                                width="350">
                        </el-table-column>
                        <el-table-column
                                prop="urunKodu"
                                label="Ürün Kodu"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="referansNo"
                                label="Referans No"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                prop="barkodNo"
                                label="Barkod No"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                prop="sutKodu"
                                label="SUT Kodu"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot="header" slot-scope="scope">
                                <el-input clearable v-on:clear="clearable" v-model="search" v-on:input="searchMethod"
                                          placeholder="Ara" size="mini"></el-input>
                            </template>
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="200"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content='Aktif Yap'
                                            :open-delay="200"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='0'"
                                            @click="durumChange(scope.row,scope.$index,urunListesi,1)"
                                            type="text"
                                            icon="mdi mdi-play mdi-24px">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="200"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='1'"
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next, jumper, total"
                            :total="total"
                            @size-change="handleSizeChange"
                            @current-change="pageChange"
                            :page-sizes="[10, 20, 50, 100]"
                            :current-page.sync="page"
                            :next-click.sync="page"
                            :prev-click.sync="page"
                            @next-click="pageChange"
                            @prev-click="pageChange">
                    </el-pagination>
                </div>

            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="urunForm" :rules="rulesAracUrun" ref="urunForm" @submit.native.prevent="enter"
                             class="demo-ruleForm">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Ürün Adı'
                                                  prop="urunAdi">:
                                        <el-input
                                                v-model="urunForm.urunAdi"
                                                placeholder='Ürün Adı Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Ürün Kodu'
                                                  v-mask="'###.##.##.##.###'"
                                                  prop="urunKodu">:
                                        <el-input
                                                v-model="urunForm.urunKodu"
                                                placeholder='Ürün Kodu Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Referans No'
                                                  prop="referansNo">:
                                        <el-input
                                                v-model="urunForm.referansNo"
                                                placeholder='Referans No Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Barkod No'
                                                  prop="barkodNo">:
                                        <el-input
                                                v-model="urunForm.barkodNo"
                                                placeholder='Barkod No Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='SUT Kodu'
                                                  prop="sutKodu">:
                                        <el-input
                                                v-model="urunForm.sutKodu"
                                                placeholder='SUT Kodu Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="urunTanimla('urunForm')"
                                           type="primary" class="estas-buton">
                                    Tanımla
                                </el-button>
                                <el-button class="estas-buton" v-else size="small" v-on:click="guncelleme('urunForm')" type="primary">
                                    Güncelle
                                </el-button>
                                <el-button class="estas-buton-border" v-if="!btnVisible" size="small" v-on:click="vazgec('urunForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["urunAdi"]}}" ürününü silmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="durumChange(selection,selectionIndex,urunListesi,0), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import notification from '../../../../notification'
    import urunOrtopediService from "../../../../WSProvider/UrunOrtopediService";

    export default {
        name: "OrtopediUrun",
        data() {
            return {
                page: 0,
                sizes: 10,
                postPage: 0,
                total: null,
                selectIcon: '1',
                radio: '1',
                urunListesi: [],
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                search:'',
                urunForm: {
                    urunKodu:'',
                    referansNo:'',
                    barkodNo: '',
                    urunAdi: '',
                    sutKodu: '',
                },
                rulesAracUrun: {
                    urunAdi: [{
                        required: true,
                        message: "Lütfen Ürün Adı Giriniz",
                        trigger: 'blur'
                    }],
                    urunKodu: [{
                        required: true,
                        message: "Lütfen Ürün Kodu Giriniz",
                        trigger: 'blur'
                    }],
                    barkodNo: [{
                        required: true,
                        message: "Lütfen Barkod No Giriniz",
                        trigger: 'blur'
                    }],
                    sutKodu: [{
                        required: true,
                        message: "Lütfen SUT Kodu Giriniz",
                        trigger: 'blur'
                    }],
                    referansNo: [{
                        required: true,
                        message: "Lütfen Referans No Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        mounted() {
            this.ortopediUrunCount();
            this.getUrunListesi()
        },
        methods: {
            ortopediUrunCount() {
                urunOrtopediService.urunOrtopediCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = response.data;
                    }
                });
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getUrunListesi();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.getUrunListesi();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getUrunListesi();
            },
            getUrunListesi() {
                urunOrtopediService.urunOrtopediListesi(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        this.urunListesi = response.data;
                        // this.total = response.data.length
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                this.urunForm.urunAdi = scope.urunAdi;
                this.urunForm.urunKodu = scope.urunKodu;
                this.urunForm.referansNo = scope.referansNo;
                this.urunForm.barkodNo = scope.barkodNo;
                this.urunForm.sutKodu = scope.sutKodu;
                this.updateKodu = scope.oUrunId;
                this.btnVisible = false;
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            enter(){
                if(this.btnVisible){
                    this.urunTanimla('urunForm') ;
                }else this.guncelleme('urunForm')
            },
            urunTanimla(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        urunOrtopediService.urunOrtopediTanimlama(this.urunForm.urunKodu,this.urunForm.referansNo,this.urunForm.barkodNo,this.urunForm.urunAdi,this.urunForm.sutKodu).then((response) => {
                            if (response.status === 200) {
                                this.urunListesi.push(response.data);
                                notification.Status('success', this, 'Ürün başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ürün zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        urunOrtopediService.urunOrtopediGuncelleme(this.updateKodu, this.urunForm.referansNo,this.urunForm.barkodNo,this.urunForm.urunAdi,this.urunForm.sutKodu).then((response) => {
                            if (response.status === 200) {
                                this.urunListesi.splice(this.selectionIndex, 1);
                                this.urunListesi.splice(this.selectionIndex, 0, {
                                    urunAdi: response.data.urunAdi,
                                    oUrunId: response.data.oUrunId,
                                    urunKodu: response.data.urunKodu,
                                    referansNo: response.data.referansNo,
                                    barkodNo: response.data.barkodNo,
                                    sutKodu: response.data.sutKodu
                                });
                                notification.Status('success', this, 'Ürün başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ürün zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            durumChange(selection, index, list,durum) {
                urunOrtopediService.urunOrtopediDurumGuncelle(selection.oUrunId,durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Ürün durumu başarıyla değiştirildi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },


            searchMethod(val) {
                if (val !== '') {
                    var dizi = [];
                    urunOrtopediService.urunKoduArama(val,this.selectIcon).then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                dizi.push(e);
                            });
                            this.urunListesi = dizi;
                        } else notification.Status(response.status, this)
                    })
                } else this.clearable();
            },
            clearable() {
                this.urunListesi = [];
                this.getUrunListesi();
            },

        }
    }
</script>

<style scoped>
    .el-pagination {
        text-align: right !important;
    }
</style>